import { render, staticRenderFns } from "./tuiguang.vue?vue&type=template&id=0a4b9537&scoped=true&"
import script from "./tuiguang.vue?vue&type=script&lang=js&"
export * from "./tuiguang.vue?vue&type=script&lang=js&"
import style0 from "./tuiguang.vue?vue&type=style&index=0&id=0a4b9537&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4b9537",
  null
  
)

export default component.exports